/**
 * OOI-specific experiments should be listed here.
 * scope: viewer-apps-14bcded7-0066-7c35-14d7-466cb3f09103
 */
export const OOI_EXPERIMENTS = {
  /**
   * Blog Live Site Editor Deprecation
   */
  LIVE_SITE_EDITOR_DEPRECATION: 'liveSiteEditorDeprecation',
  /**
   * Does not allow to install blog members area apps in the editor.
   * https://bo.wix.com/guineapig/experiments/4288493
   */
  DONT_REGISTER_MEMBER_PAGES: 'specs.wixBlog.DontRegisterMemberPages',
  USE_LAYOUT_FIXER: 'specs.wixBlog.UseLayoutFixer',
  HASHTAG_PAGE_USE_FEED_PAGE: 'specs.wixBlog.HashtagPageUseFeedPage',
  /**
   * Whether the site is on Nile.
   */
  DRAFT_POST_PROXY_NILE_ROUTING: 'draftPostProxyNileRoutingExperiment',
  /**
   * Enables the category header baked into the Blog widget on new installations
   * (instead of installing the Blocks category header widget plugin).
   */
  OOI_CATEGORY_HEADER_BLOG: 'ooiCategoryHeaderBlog',
} as const;
